export default __webpack_public_path__ + "static/media/wojciech_pszcz.f657a551.mp3";